import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'
import { OtInbound } from '../../interfaces/Planner/Planner'

export const busquedaInitialState: OtInbound = {
  workOrderId: 0,
  typeWorkOrderId: 0,
  createdAt: '',
  workOrderStateId: 0,
  workOrderStateName: '',
  workOrderCode: '',
  priority: 0,
  asnId: 0,
  asnNumber: '',
  asnStateId: 0,
  asnStateName: '',
  supplierId: 0,
  supplierName: '',
  supplierOriginId: 0,
  supplierOriginName: '',
  fefo: false,
  skuQty: 0,
  skuPriorityQty: 0,
  unitsQty: 0,
  unitsPriorityQty: 0,
  rowNum: 0
}

export const dataGridSettings: DataGridSettings = {
  spacing: 2,
  sortingMode: 'single',
  columns: [
    {
      title: 'Prioridad Almacén',
      dataField: 'priority',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Id OT',
      dataField: 'workOrderCode',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: true
    },
    {
      title: 'Id ASN',
      dataField: 'asnNumber',
      xs: 12,
      sm: 1,
      lg: 1,
      allowSorting: true
    },

    {
      title: 'Fecha creación',
      dataField: 'CreatedAt',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Proveedor',
      dataField: 'SupplierName',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Estado',
      dataField: 'asnStateName',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Acciones',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    }
  ]
}

export const dataGridPackingListDetailSettings: DataGridSettings = {
  spacing: 1,
  sortingMode: 'single',
  columns: [
    {
      title: 'ASN',
      dataField: 'asnNumber',
      xs: 12,
      sm: 6,
      lg: 6,
      allowSorting: false
    },
    {
      title: 'Acciones',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 6,
      allowSorting: false
    }
  ]
}
